/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * Re-initialize Swym (Wishlist Plus) "Add to Wishlist" buttons inside dynamically
 * loaded content.
 *
 * The collection Quick View fetches the product section over AJAX and injects it with
 * replaceChildren(), so it never triggers Swym's initial page-load scan. Without this,
 * the wishlist button in the modal is never bound: the click falls through to the
 * enclosing product form and adds the item to the cart instead.
 */
(function () {
  var SWYM_BUTTON_SELECTOR = '.swym-add-to-wishlist';

  function initSwymButtons() {
    // Wishlist Plus loads asynchronously; SwymCallbacks runs queued fns immediately
    // once _swat is ready, so pushing again on each modal load re-binds new buttons.
    // NOTE: initializeActionButtons() takes a CONTAINER selector to scan within, not
    // the button's own selector. "body" re-scans the whole page (idempotent).
    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(function (swat) {
      swat.initializeActionButtons('body');
    });
  }

  function watchModal(modal) {
    var inner = modal.querySelector('.modal__inner');
    if (!inner || inner.dataset.swymObserved) return;
    inner.dataset.swymObserved = 'true';

    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length && inner.querySelector(SWYM_BUTTON_SELECTOR)) {
          initSwymButtons();
          break;
        }
      }
    }).observe(inner, { childList: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[id^="modal-quick-view-"]').forEach(watchModal);
  });
})();

